module.exports = __webpack_public_path__ + "img/20180120_1.d6ac9602.jpeg";